// import React, { useState, useEffect } from "react";
import GUI_Header from "./GUI_Header";
import GUI_Credit from "./GUI_Credit";
import GUI_InputTextArea from "./GUI_InputTextArea";
import T from "../TheTool";

function GUIset_TextArea(props) {
	var title1 = T.getValue(props.title, "");
	var desc1 = T.getValue(props.desc, "");
	var txtButton  = T.getValue(props.txtButton, "Analyze");
	var label1 = T.getValue(props.label1, "Input");
	var label2 = T.getValue(props.label2, "");
	var placeholder1 = T.getValue(props.placeholder, "");

	return (
		<div className="todoapp stack-large">
		<GUI_Header title={title1} desc={desc1} />
		<div style={{ marginTop: "3em" }}> </div>
		<GUI_InputTextArea
			id="inputItemList"
			className="textarea_001"
			placeholder={placeholder1}
			// placeholder={"name,weight,value\nname,weight,value\nname,weight,value"}
			// style={{ minHeight: "308px", whiteSpace: "pre-line" , fontSize: 28  }}
			style={{ minHeight: "308px", whiteSpace: "pre-line" }}
			// defaultValue="A,12,4B,4,10 C,2,2 D,1,2 E,1,1"
			// value={guiTxtArea}
			// onChange={guiTxtAreaChange}
			area1Change={props.guiTxtAreaChange}
			text1={props.guiTxtArea}
			label={label1}
			label2={label2}
		/>
		<div style={{ display: "flex", marginLeft: "3%", marginRight: "3%" }}>
			<button
				onClick={() => props.buttonClick()}
				className="btn btn__primary btn__lg"
				style={{ flex: 1, height: 50 }}
			>
				{txtButton}
			</button>
		</div>
		<div style={{ marginTop: "3em" }}> </div>
		{props.partResult}
		<GUI_Credit />
		</div>
	);
}
export default GUIset_TextArea;